import Styles from "./Contacts.module.scss";

interface ContactsProps{
    contacts:any;
    handleContactClick:(id:string)=>void;
}

const Contacts = ({contacts,handleContactClick}:ContactsProps) => {
  return (
    <div className={Styles.screen}>
        <div className={Styles.container}>
            {
                contacts.map((option:any)=>{
                    return (
                       <div key={option.label}>
                        <div className={Styles.label}>
                            {option.label}
                        </div>
                         <div className={Styles.contacts}>
                         {
                             option.options.map((contact:any)=>{
                                 return(
                                     <div className={Styles.contact_card} onClick={()=>{handleContactClick(contact.id)}} key={contact.id}>
                                         <div className={Styles.pfp}>
                                             <img src={contact.pfp}/>
                                         </div>
                                         <div className={Styles.label}>
                                             {contact.label}
                                         </div>
                                     </div>
                                 )
                             })
                         }
                     </div>
                     </div >
                    )
                })
            }
           
        </div>
    </div>
  )
}

export default Contacts
